import React, { useState } from 'react';
import { Grid, Typography, Tooltip, Button, useMediaQuery, Box } from '@mui/material';
import { useTheme } from '@mui/system';
import Confetti from 'react-confetti';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { variants } from '../../../variants/variants';
import UserAvatar from '../../../common/UserAvatar';

const SmallShabashWinnerCard = ({ winner, setSelectedWinner, setOpen }) => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const [hovered, setHovered] = useState(false);

  const handleOverviewClick = () => {
    setSelectedWinner(winner);
    setOpen(true);
  };

  return (
    <Box
      width={'100%'}
      marginBottom={1}
      sx={{
        height: isSm ? '160px' : '32vh',
        border: 1,
        borderColor: 'divider',
        boxShadow: 'none',
        borderRadius: '8px',
        textAlign: 'center',
        transition: 'all 0.1s ease-in-out',
        '&:hover': {
          transform: 'scale(1.0)',
          boxShadow: variants.BOX_SHADOW,
        },
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {hovered && <Confetti numberOfPieces={200} width={300} height={150} recycle={true} />}
      <Grid
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          wrap: 'nowrap',
          padding: 2,
          position: 'relative',
        }}
      >
        <Tooltip title='Overview'>
          <Button
            onClick={handleOverviewClick}
            sx={{
              position: 'absolute',
              top: 0,
              right: 0,
              zIndex: 1,
            }}
          >
            <InfoOutlinedIcon />
          </Button>
        </Tooltip>
        <Box display={'flex'} justifyContent={'start'} width={'90%'}>
          <UserAvatar src={winner?.nomineePhoto} sx={{ width: 60, height: 60, mb: 2 }} />
          <Box display={'flex'} flexDirection={'column'} justifyContent={'start'} alignItems={'start'} p={1}>
            <Typography
              variant='h6'
              sx={{
                mb: isSm ? 0 : 1,
                overflowWrap: 'break-word',
                wordWrap: 'break-word',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                [theme.breakpoints.down('sm')]: {
                  fontSize: '1rem',
                },
              }}
            >
              {winner?.name}
            </Typography>
            <Typography
              variant='h6'
              sx={{
                mb: isSm ? 0 : 1,
                overflowWrap: 'break-word',
                wordWrap: 'break-word',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                [theme.breakpoints.down('sm')]: {
                  fontSize: '0.8rem',
                },
                color: 'grey',
              }}
            >
              {winner?.empCode}
            </Typography>
            <Typography
              variant='subtitle1'
              color='text.secondary'
              sx={{
                mb: isSm ? 0 : 1,
                overflowWrap: 'break-word',
                wordWrap: 'break-word',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                [theme.breakpoints.down('sm')]: {
                  fontSize: '0.8rem',
                },
                color: 'grey',
              }}
            >
              {winner?.department}
            </Typography>
          </Box>
        </Box>

        <Typography
          noWrap
          variant='subtitle1'
          color='text.secondary'
          sx={{
            mb: isSm ? 0 : 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            [theme.breakpoints.down('sm')]: {
              fontSize: '0.8rem',
            },
            maxWidth: '200px',
          }}
        >
          {winner?.designation}
        </Typography>
      </Grid>
    </Box>
  );
};

export default SmallShabashWinnerCard;
